// extracted by mini-css-extract-plugin
module.exports = {"heading":"Heading_heading__IvTjx","title":"Heading_title__m2VYn","small":"Heading_small__DohDw","large":"Heading_large__I6ZQk"};